/**
 * Shared layout tokens for the chromeless auth modal (`AuthDialog`).
 * Use these when you need the same shell (e.g. a custom dialog that still matches auth popups).
 */
export const AUTH_DIALOG_DEFAULT_RETURN_URL = "/";

/** DialogContent: no outer “panel”; inner cards provide shape and shadow. Use `overflow-visible` so the close control can sit outside the card. */
export const AUTH_DIALOG_CONTENT_CLASSNAME =
	"w-[calc(100vw-2rem)] max-w-md gap-0 overflow-visible border-0 bg-transparent p-0 shadow-none sm:rounded-none";

/** Scroll region for tall forms; keeps the shell from clipping the close button. */
export const AUTH_DIALOG_BODY_CLASSNAME =
	"max-h-[min(90vh,880px)] w-full overflow-y-auto overflow-x-visible";

/**
 * Close button: muted grey icon only (no pill).
 * Pair with `AUTH_DIALOG_CLOSE_POSITION_CLASSNAME` on the same node — positioning is relative to the card wrapper.
 */
export const AUTH_DIALOG_CLOSE_CLASSNAME =
	"rounded-none border-0 bg-transparent p-2 text-muted-foreground/55 shadow-none opacity-100 ring-offset-background hover:bg-transparent hover:text-muted-foreground/70 hover:opacity-90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-muted-foreground/30 focus-visible:ring-offset-2 data-[state=open]:bg-transparent";

/** Places the close control inside the card’s top-right corner. */
export const AUTH_DIALOG_CLOSE_POSITION_CLASSNAME =
	"absolute right-5 top-5 z-[70]";

/** Tab strip when `showSignupTab` is enabled */
export const AUTH_DIALOG_TAB_LIST_CLASSNAME = "flex gap-1 rounded-lg bg-muted p-1";

export function authDialogTabTriggerClassName(active: boolean): string {
	return active
		? "flex-1 rounded-md bg-card py-2 text-sm font-medium text-foreground shadow-sm transition-colors"
		: "flex-1 rounded-md py-2 text-sm font-medium text-muted-foreground transition-colors hover:text-foreground";
}
